export const blockIconsPrivacyandsecurityReportNew = (
	<span className='material-symbols-outlined'>report</span>
);
